module.exports = __webpack_public_path__ + "images/search-btn-7e9df080b318ad229c43ad549539598a.png";